import React from "react";
import { Link } from "react-router-dom";
import OptimizedImage from "./ΟptimizedImage";

// Βοηθητική συνάρτηση για την αφαίρεση των HTML tags
const stripHtml = (html) => {
  if (!html) return '';
  const tempDiv = document.createElement("div");
  tempDiv.innerHTML = html;
  return tempDiv.textContent || tempDiv.innerText || "";
};

/**
 * Component για την εμφάνιση της ενότητας Καθημερινής Στήλης (π.χ. Metal on Screen).
 * Εμφανίζει μόνο το πιο πρόσφατο άρθρο σε full-width, οριζόντια διάταξη.
 * @param {object[]} articles - Λίστα άρθρων (posts) με κατηγορία dailycolumn.
 * @param {string} title - Ο τίτλος της στήλης (π.χ., "Metal on Screen").
 */
const DailyColumnSection = ({ articles, title = "DAILY COLUMN" }) => {
  if (!articles || articles.length === 0)
    return null;

  const featured = articles[0];
  const articleCategory = featured.category || "Daily Column";

  return (
    <section className="daily-column-section bg-dark text-white py-5">
      <div className="container">
        {/* Τίτλος */}
        <h2 className="text-info fw-bold border-bottom border-2 border-info d-inline-block mb-4 px-2">
          {title.toUpperCase()}
        </h2>

        {/* Κύρια Κάρτα Στήλης (Full-width row) */}
        <div className="row g-0 border border-info rounded shadow-lg overflow-hidden">
          
          {/* Αριστερή πλευρά: Εικόνα (70% σε desktop) */}
          <div className="col-lg-7">
            <Link to={`/articles/${featured.id}`}>
              <OptimizedImage
                src={featured.mainImageUrl || featured.image}
                alt={featured.title}
                className="img-fluid w-100"
                style={{ height: "350px", objectFit: "cover" }}
              />
            </Link>
          </div>

          {/* Δεξιά πλευρά: Κείμενο και Λεπτομέρειες (30% σε desktop) */}
          <div className="col-lg-5 p-4 d-flex flex-column bg-secondary text-white">
            
            <span className="badge bg-info text-dark fw-bold mb-2 align-self-start">
              {featured.genre || articleCategory}
            </span>

            <Link to={`/articles/${featured.id}`} className="text-decoration-none">
              <h3 className="fw-bolder text-white hover-text-info mb-3">
                {featured.title}
              </h3>
            </Link>
            
            <p className="small text-light flex-grow-1">
              {stripHtml(featured.content)?.slice(0, 180)}...
            </p>

            <div className="mt-3">
              <small className="text-muted d-block mb-1">
                Από: {featured.author || 'Συντακτική Ομάδα'}
              </small>
              <small className="text-info">
                {featured.createdAt?.toDate().toLocaleDateString("el-GR", {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                })}
              </small>
            </div>
            
          </div>
        </div>
      </div>
    </section>
  );
};

export default DailyColumnSection;
